module.exports = __webpack_public_path__ + "static/assets/62fbe485473d31987bc0e7ee3b6abefc.png";